import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined';
import TocOutlinedIcon from '@mui/icons-material/TocOutlined';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { FC, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { routes, tabs } from 'src/enums';
import styles from './TopTabs.module.css';

export const TopTabsProfile: FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [tab, setTab] = useState<string>(tabs.profile);

  useEffect(() => {
    if (pathname.endsWith(tabs.profile)) setTab(tabs.profile);
    if (pathname.endsWith(tabs.scopes)) setTab(tabs.scopes);
    if (pathname.endsWith(tabs.eventLog)) setTab(tabs.eventLog);
  }, [pathname]);

  return (
    <Box className={styles.container}>
      <Tabs
        className={styles.tabs}
        value={tab}
        classes={{ indicator: styles.tabIndicator }}
      >
        <Tab
          icon={<AccountCircleOutlinedIcon />}
          iconPosition="start"
          className={styles.tab}
          label="Профиль"
          id="0"
          value={tabs.profile}
          onClick={() => navigate(`/${routes.profile}/${tabs.profile}`)}
        />
        <Tab
          icon={<GppGoodOutlinedIcon />}
          iconPosition="start"
          className={styles.tab}
          label="Разрешения"
          id="1"
          value={tabs.scopes}
          onClick={() => navigate(`/${routes.profile}/${tabs.scopes}`)}
        />
        <Tab
          icon={<TocOutlinedIcon />}
          iconPosition="start"
          className={styles.tab}
          label="Журнал"
          id="2"
          value={tabs.eventLog}
          onClick={() => navigate(`/${routes.profile}/${tabs.eventLog}`)}
        />
      </Tabs>
    </Box>
  );
};